import { render, staticRenderFns } from "./sd.vue?vue&type=template&id=2bdeaeb7"
import script from "./sd.vue?vue&type=script&lang=js"
export * from "./sd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports